import { Dispatch, SetStateAction, useEffect } from "react";

import { useSingleExcelInputUpload } from "../reuseables/dragUpload.hooks";

export default function ExcelFileInput({ setExcelData }: { setExcelData: Dispatch<SetStateAction<any[] | null>> }) {
  const { register, excelData } = useSingleExcelInputUpload<any[]>();

  useEffect(() => {
    setExcelData(excelData);

    // eslint-disable-next-line
  }, [excelData]);

  return <input type="file" multiple {...register()} />;
}
